import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Inject, Input, OnInit, inject } from '@angular/core';

import { DataCyDirective } from '@base/common/directives/data-cy.directive';

import { Notification, NotificationType, ToasterService } from '@services/toaster.service';

import { fromEvent, repeat, timer } from 'rxjs';
import { first, takeUntil, tap } from 'rxjs/operators';

@Component({
    selector: 'checkout-toaster',
    standalone: true,
    imports: [CommonModule, DataCyDirective],
    templateUrl: './toaster.component.html',
    styleUrl: 'toaster.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToasterComponent implements OnInit {
    @Input({ required: true }) public notification: Notification;
    public toasterService: ToasterService = inject(ToasterService);

    public toasterClass: string = '';

    public readonly mouseenter$ = fromEvent(this.elementRef.nativeElement, 'mouseenter');
    public readonly mouseleave$ = fromEvent(this.elementRef.nativeElement, 'mouseleave');

    constructor(@Inject(ElementRef) private readonly elementRef: ElementRef<HTMLElement>) {}
    public ngOnInit(): void {
        this.toasterClass = this.getClass(this.notification);

        const durationMs = this.notification.durationSeconds * 1000;

        timer(durationMs)
            .pipe(
                takeUntil(this.mouseenter$),
                repeat({ delay: () => this.mouseleave$ }),
                first(),
                tap(() => this.hideNotification()),
            )
            .subscribe();
    }

    public hideNotification(): void {
        this.toasterService.hideNotification(this.notification);
    }

    public getClass(notification: Notification): string {
        const classes = {
            [NotificationType.INFO]: 'is-info',
            [NotificationType.WARNING]: 'is-warning',
            [NotificationType.ERROR]: 'is-error',
            [NotificationType.SUCCESS]: 'is-success',
        };

        return classes[notification.type] || classes[NotificationType.INFO];
    }
}
